import React from 'react';
import { CheckCircle } from 'lucide-react';

const Precos: React.FC = () => {
    return (
        <div className="min-h-screen bg-[#f6f7f8] dark:bg-[#101922] font-sans py-20 px-6">
            <div className="max-w-7xl mx-auto">
                <div className="flex flex-col items-center text-center gap-2 mb-12">
                    <h1 className="text-[#333333] dark:text-white text-4xl font-bold tracking-tight">Planos e Preços</h1>
                    <p className="text-[#666666] dark:text-[#9dabb9] text-lg max-w-2xl">Escolha o plano ideal para o seu negócio.</p>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-start max-w-4xl mx-auto">
                    <div className="flex flex-col rounded-xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-[#111827] p-6 shadow-sm h-full">
                        <div className="flex-grow">
                            <h3 className="text-xl font-bold text-[#333333] dark:text-white">Plano Básico</h3>
                            <p className="mt-1 text-gray-500 dark:text-gray-400">Ideal para freelancers e pequenas empresas.</p>
                            <div className="mt-4">
                                <span className="text-4xl font-extrabold text-[#333333] dark:text-white">R$99</span>
                                <span className="ml-1 text-lg font-medium text-gray-500 dark:text-gray-400">/mês</span>
                            </div>
                            <ul className="mt-6 space-y-3 text-gray-600 dark:text-gray-300">
                                <li className="flex items-center gap-2">
                                    <CheckCircle className="text-green-500 size-5" />
                                    <span>Até 10 orçamentos por mês</span>
                                </li>
                                <li className="flex items-center gap-2">
                                    <CheckCircle className="text-green-500 size-5" />
                                    <span>Importação de arquivos BIM</span>
                                </li>
                                <li className="flex items-center gap-2">
                                    <CheckCircle className="text-green-500 size-5" />
                                    <span>Suporte via e-mail</span>
                                </li>
                            </ul>
                        </div>
                        <button className="mt-8 w-full flex items-center justify-center rounded-lg h-12 px-6 bg-[#137fec] text-white text-base font-bold hover:bg-opacity-90 transition-colors shadow-lg shadow-[#137fec]/30">
                            Escolher Plano Básico
                        </button>
                    </div>
                    <div className="flex flex-col rounded-xl border-2 border-[#137fec] dark:border-[#137fec] p-6 bg-white dark:bg-[#111827] shadow-lg relative h-full">
                        <div className="absolute -top-3.5 left-1/2 -translate-x-1/2">
                            <span className="inline-block rounded-full bg-[#137fec] px-3 py-1 text-xs font-semibold uppercase tracking-wider text-white">Mais Popular</span>
                        </div>
                        <div className="flex-grow">
                            <h3 className="text-xl font-bold text-[#333333] dark:text-white">Plano Premium</h3>
                            <p className="mt-1 text-gray-500 dark:text-gray-400">Para construtoras e projetos complexos.</p>
                            <div className="mt-4">
                                <span className="text-4xl font-extrabold text-[#333333] dark:text-white">R$299</span>
                                <span className="ml-1 text-lg font-medium text-gray-500 dark:text-gray-400">/mês</span>
                            </div>
                            <ul className="mt-6 space-y-3 text-gray-600 dark:text-gray-300">
                                <li className="flex items-center gap-2">
                                    <CheckCircle className="text-green-500 size-5" />
                                    <span>Orçamentos ilimitados</span>
                                </li>
                                <li className="flex items-center gap-2">
                                    <CheckCircle className="text-green-500 size-5" />
                                    <span>Importação de arquivos BIM</span>
                                </li>
                                <li className="flex items-center gap-2">
                                    <CheckCircle className="text-green-500 size-5" />
                                    <span>Relatórios avançados</span>
                                </li>
                                <li className="flex items-center gap-2">
                                    <CheckCircle className="text-green-500 size-5" />
                                    <span>Suporte prioritário (telefone e e-mail)</span>
                                </li>
                            </ul>
                        </div>
                        <button className="mt-8 w-full flex items-center justify-center rounded-lg h-12 px-6 bg-[#137fec] text-white text-base font-bold hover:bg-opacity-90 transition-colors shadow-lg shadow-[#137fec]/30">
                            Escolher Plano Premium
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Precos;
